<template>
  <div>
    <h1 class="common__main-title">Unfinished Tasks</h1>
    <Search
      class="search"
      @search="search"
    />
    <Pager v-model="pager" @changePage="changePage" class="mb-2" />
    <UnfinishedTask :unfinishedTasks="unfinishedTasks"/>
    <Pager v-model="pager" @changePage="changePage" />
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/components/parts/Pager.vue';
import UnfinishedTask from '@/components/parts/unfinishedTask/UnfinishedTask.vue';
import Search from '@/components/parts/unfinishedTask/UnfinishedTaskSearch.vue';
import { mapState } from 'vuex';
import Loading from '@/components/parts/modal/Loading.vue'

export default {

  data() {
    return {
      isLoading: false,
      conditions: null,
    };
  },

  computed: {
    ...mapState({
      unfinishedTasks: (state) => state.deadlines.deadlines,
      pager: (state) => state.deadlines.pager,
    }),
  },

  components: {
    Search,
    Pager,
    UnfinishedTask,
    Loading,
  },

  methods: {
    changePage(page) {
      this.search(this.conditions, page);
    },
    async search(conditions, page = 1) {
      this.isLoading = true;
      this.conditions = conditions;
      try {
        await this.$store.dispatch('fetchDeadlines', { conditions, page });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
